import React from 'react';
import ClassAssembly  from 'views/ClassAssembly6B';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;